module.exports = __webpack_public_path__ + "media/flags/iq-0a77c7fd.svg";